import {Chip} from "@material-ui/core";
import {useTranslation} from 'react-i18next';
import React from "react";
import "./FilterTag.css";
import CloseIcon from '@material-ui/icons/Close'

function FilterTag({
                       filterTag,
                       handleDelete,
                       resetButtonHandler,
                       rerender,
                   }) {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            {(rerender || !rerender) ? (
                <div className="tag-section-filter">
                    <div className="filter-tag-zone">
                        <div className="filter-tag-body">
                            <Chip size="small"
                                  variant="outlined"
                                  className="filter-tag-chip"
                                  style={{color: 'black', fontWeight: "bold", border: "1px solid black"}}
                                  label="Filters"
                            />
                        </div>
                    </div>
                    {filterTag.automation_type_id && (
                        <div className="filter-tag-zone">
                            {/*<div className="filter-tag-title">*/}
                            {/*    <span className="filter-tag-title-label">{t('CONTENT.BOT.AUTOMATION-TYPE')}</span>*/}
                            {/*</div>*/}
                            <div className="filter-tag-body">
                                {filterTag.automation_type_id.map((item, i) => {
                                    return (
                                        <Chip key={i} size="small" color="primary"
                                              className="filter-tag-chip"
                                              style={{backgroundColor: 'var(--polo-blue)'}}
                                              deleteIcon={<CloseIcon/>}
                                              onDelete={(e) => handleDelete(e, item, filterTag, "Automation Type")}
                                              id={item.item_id} label={item.item_name}/>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {filterTag.business_process_id && (
                        <div className="filter-tag-zone">
                            {/*<div className="filter-tag-title">*/}
                            {/*    <span className="filter-tag-title-label">{t('CONTENT.BOT.BUSINESS-PROCESS')}</span>*/}
                            {/*</div>*/}
                            <div className="filter-tag-body">
                                {filterTag.business_process_id.map((item, i) => {
                                    return (
                                        <Chip
                                            key={i}
                                            size="small"
                                            className="filter-tag-chip"
                                            color="secondary"
                                            style={{backgroundColor: 'var(--roman)'}}
                                            deleteIcon={<CloseIcon/>}
                                            onDelete={(e) => handleDelete(e, item, filterTag, "Business Process")}
                                            id={item.item_id}
                                            label={item.item_name}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {filterTag.category_id && (
                        <div className="filter-tag-zone">
                            {/*<div className="filter-tag-title">*/}
                            {/*    <span className="filter-tag-title-label">{t('CONTENT.BOT.CATEGORY')}</span>*/}
                            {/*</div>*/}
                            <div className="filter-tag-body">
                                {filterTag.category_id.map((item, i) => {
                                    return (
                                        <Chip
                                            key={i}
                                            size="small"
                                            className="filter-tag-chip"
                                            color="primary"
                                            style={{backgroundColor: 'var(--west-side)'}}
                                            deleteIcon={<CloseIcon/>}
                                            onDelete={(e) => handleDelete(e, item, filterTag, "Category")}
                                            onClick={(e) => handleDelete(e)}
                                            id={item.item_id}
                                            label={item.item_name}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {filterTag.security_stage_id && (
                        <div className="filter-tag-zone">
                            {/*<div className="filter-tag-title">*/}
                            {/*    <span className="filter-tag-title-label">{t('CONTENT.BOT.SECURITY-STAGE')}</span>*/}
                            {/*</div>*/}
                            <div className="filter-tag-body">
                                {filterTag.security_stage_id.map((item, i) => {
                                    return (
                                        <Chip
                                            key={i}
                                            size="small"
                                            color="primary"
                                            className="filter-tag-chip"
                                            style={{backgroundColor: 'var(--mist-gray)'}}
                                            deleteIcon={<CloseIcon/>}
                                            onDelete={(e) => handleDelete(e, item, filterTag, "Security Stage")}
                                            id={item.item_id}
                                            label={item.item_name}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {filterTag.application_id && (
                        <div className="filter-tag-zone">
                            {/*<div className="filter-tag-title">*/}
                            {/*    <span className="filter-tag-title-label">{t('CONTENT.BOT.SECURITY-STAGE')}</span>*/}
                            {/*</div>*/}
                            <div className="filter-tag-body">
                                {filterTag.application_id.map((item, i) => {
                                    return (
                                        <Chip
                                            key={i}
                                            size="small"
                                            color="primary"
                                            className="filter-tag-chip"
                                            style={{backgroundColor: 'var(--mist-gray)'}}
                                            deleteIcon={<CloseIcon/>}
                                            onDelete={(e) => handleDelete(e, item, filterTag, "Application")}
                                            id={item.item_id}
                                            label={item.item_name}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    <div
                        onClick={resetButtonHandler}
                    >
                        <Chip size="small"
                              color="primary"
                              className="filter-tag-chip"
                              style={{backgroundColor: '#aeaeae'}}
                              label={t('CONTENT.BOT.RESET-ALL')}
                        />

                    </div>

                </div>
            ) : null}
        </React.Fragment>
    );
}

export default FilterTag;
